import { render, staticRenderFns } from "./goodsNewSetting.vue?vue&type=template&id=68b682d1&scoped=true&"
import script from "./goodsNewSetting.vue?vue&type=script&lang=js&"
export * from "./goodsNewSetting.vue?vue&type=script&lang=js&"
import style0 from "./goodsNewSetting.vue?vue&type=style&index=0&id=68b682d1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b682d1",
  null
  
)

export default component.exports